import axios from 'axios';
import {api} from "../config";

export default {
    postChangePassword(form) {
        return axios.post(api.password_change, form);
    },

    getUserInformation() {
        return axios.get(api.user_info);
    },

    postTopUp(amount, payment_type, manual_payment_proof_file,first_time = false) {
        let formData = new FormData()
        formData.append('amount',amount)
        formData.append('payment_type',payment_type)
        formData.append('manual_payment_proof_file',manual_payment_proof_file)
        formData.append('first_time',first_time)

        return axios.post(api.investors.topup, formData,{headers:{
                'Content-Type': 'multipart/form-data'
            }});
    },

    postWithdraw(form) {
        return axios.post(api.investors.withdraw, form);
    },

    /**
     * Verify top up when return from payment gateway
     * @param ref_number
     * @returns {AxiosPromise}
     */
    postVerifyLatestTopUp(ref_number) {
        return axios.post(api.investors.verify_latest_topup, {ref_number: ref_number});
    },

    getTwoFactor(){
        return axios.get(api.get_two_factor);
    },

    getQrCode(){
        return axios.get(api.get_qr_code);
    },

    authenticateTwoFactor(otp_code, secret_key, otp_type){
        return axios.post(api.authenticate_two_factor, {otp_code: otp_code, secret_key: secret_key, otp_type: otp_type});
    },

    sendEmailOTP(){
        return axios.post(api.send_email_otp);
    },
}